function clamp(value: number): number {
  return Math.min(255, Math.max(0, value))
}

export function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const match = /^#?([0-9A-Fa-f]{6})$/.exec(hex.trim())
  if (!match) return null

  const value = parseInt(match[1], 16)
  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255,
  }
}

export function rgbToHex(r: number, g: number, b: number): string {
  return `#${[r, g, b].map(channel => clamp(channel).toString(16).padStart(2, '0')).join('')}`
}

export function adjustHexColor(hex: string, amount: number): string {
  const rgb = hexToRgb(hex)
  if (!rgb) return hex

  return rgbToHex(rgb.r + amount, rgb.g + amount, rgb.b + amount)
}
